import { Link } from "react-router-dom";
import styles from "./HeaderLink.module.scss";

/**
 * Basic header link component
 * @param {image} img image to show in link
 * @param {string} to link to navigate to when clicked
 * @param {string} alert data to show in alert circle
 * @param {string} tour onboarding tour step id (data-tour)
 *
 *@return {JSX.Element}
 * @constructor
 */

const HeaderLink = ({ title, img, to, onClick, alert, text, tour }) => {
    const className = `${styles.link} ${text !== undefined ? styles.pill : ""}`;
    const label = text !== undefined ? `${title}: ${text}` : title;
    const content = (
        <>
            {alert && <div className={styles.alert}>{alert}</div>}
            <img alt="" src={img} />
            {text !== undefined && <span className={styles.pillText}>{text}</span>}
        </>
    );

    return to ? (
        <Link to={to} onClick={onClick} className={className} title={title ? title : ""} aria-label={label} data-tour={tour}>
            {content}
        </Link>
    ) : (
        <button onClick={onClick} className={className} title={title ? title : ""} aria-label={label} data-tour={tour}>
            {content}
        </button>
    );
};

export default HeaderLink;
